export default __webpack_public_path__ + "static/media/side-menu.2211f099.svg";